import { SlashCommandProps } from './slashCommand.types';

export function handleSlashCommand({
  editor,
  range,
  props
}: SlashCommandProps) {
  const { type } = props;

  switch (type) {
    case 'paragraph':
      editor.chain().focus().deleteRange(range).setNode('paragraph').run();
      break;
    case 'heading1':
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .setNode('heading', { level: 1 })
        .run();
      break;
    case 'heading2':
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .setNode('heading', { level: 2 })
        .run();
      break;
    case 'heading3':
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .setNode('heading', { level: 3 })
        .run();
      break;
    case 'todo':
      editor.chain().focus().deleteRange(range).toggleTaskList().run();
      break;
    case 'bulletList':
      editor.chain().focus().deleteRange(range).toggleBulletList().run();
      break;
    case 'orderedList':
      editor.chain().focus().deleteRange(range).toggleOrderedList().run();
      break;
    case 'blockquote':
      editor.chain().focus().deleteRange(range).toggleBlockquote().run();
      break;
    case 'divider':
      editor.chain().focus().deleteRange(range).setHorizontalRule().run();
      break;
    case 'codeBlock':
      editor.chain().focus().deleteRange(range).setCodeBlock().run();
      break;
    default:
      break;
  }
}
